import { useFormContext, useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { removeOpengraphImagePath } from "@/react/helpers/urlHelpers";
import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { FieldLabel } from "@circle-react-shared/Form/FieldLabel";
import { MediaUploader } from "@circle-react-shared/MediaUploader";
import { Form } from "@circle-react-uikit/Form";
import { SectionCard } from "@circle-react-uikit/SectionCard";
import { SEOFormItem } from "./SEOFormItem";

export const SEOForm = () => {
  const { getValues, setValue } = useFormContext();
  const opengraphImage = useWatch({ name: "opengraph_image" });
  const metaTagId = getValues("id");
  const onOpengraphImageUpload = (event: { target: { files: any[] } }) => {
    setValue("opengraph_image", {
      file: event.target.files[0],
    });
  };

  const removeOpengraphImage = () => {
    setValue("opengraph_image", {
      type: "image",
      url: null,
    });
  };

  const onOpengraphImageRemove = async () => {
    if (metaTagId) {
      const response = await reactQueryDelete<any, any>(
        removeOpengraphImagePath(metaTagId),
      );
      if (response.success) {
        removeOpengraphImage();
      }
    } else {
      removeOpengraphImage();
    }
  };

  return (
    <SectionCard
      title={t("home_page.edit_form.seo")}
      variant="fullScreen"
      fullWidth
    >
      <div className="mx-auto flex h-full flex-col">
        <SEOFormItem
          name="meta_title"
          tooltipText={t(
            "landing_page.settings.meta_tag.meta_title_description",
          )}
        >
          <Form.Input />
        </SEOFormItem>
        <SEOFormItem
          name="meta_description"
          tooltipText={t(
            "landing_page.settings.meta_tag.meta_description_description",
          )}
        >
          <Form.TextArea name="meta_description" />
        </SEOFormItem>
        <SEOFormItem
          name="opengraph_title"
          tooltipText={t(
            "landing_page.settings.meta_tag.opengraph_title_description",
          )}
        >
          <Form.Input />
        </SEOFormItem>
        <SEOFormItem
          name="opengraph_description"
          tooltipText={t(
            "landing_page.settings.meta_tag.opengraph_description_description",
          )}
        >
          <Form.TextArea name="opengraph_description" />
        </SEOFormItem>
        <div
          id="field-opengraph_image"
          key="field-opengraph_image"
          className="mt-3 flex"
        >
          <FieldLabel
            field="opengraph_image"
            label={t("landing_page.settings.meta_tag.opengraph_image")}
            description={t(
              "landing_page.settings.meta_tag.opengraph_image_description",
            )}
          />
          <div className="w-full">
            <MediaUploader
              id="opengraph_image"
              name="opengraph_image"
              media={opengraphImage || {}}
              onMediaUpload={onOpengraphImageUpload}
              onRemoveMedia={onOpengraphImageRemove}
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};
